import { render } from "./BateriesSystem20V.vue?vue&type=template&id=63ccc91e"
import script from "./BateriesSystem20V.vue?vue&type=script&lang=js"
export * from "./BateriesSystem20V.vue?vue&type=script&lang=js"

import "./BateriesSystem20V.vue?vue&type=style&index=0&id=63ccc91e&lang=css"

import exportComponent from "/builds/elektro3-projects/elektro3-web/elektro3-komatools-web/elektro3-komatools-web-front/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__